import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../constants/rentalPortal'
import { PROFILE_ROUTE_NAMES } from '../../../../constants/route'
import { formatNumberWithSeparators } from '../../../../utils/number'
import {
  getListingRentDisplayValue,
  toListingFlatNumber,
} from '../../../RentalPortalListing'
import { getApplicantShortDate } from '../RentalPortalApplicantProfileHeaderInfoItems'

export function getApplicantMatchedListingFacts({ matchedListing, t }) {
  const facts = []

  if (matchedListing?.flat?.room_count != null) {
    facts.push(
      t('RentalPortal.ListingFormFlatFactsRoomsKey', {
        count: toListingFlatNumber(matchedListing.flat.room_count),
      })
    )
  }

  if (Number.isFinite(matchedListing?.flat?.area)) {
    facts.push(
      `${formatNumberWithSeparators(matchedListing.flat.area)} ${t('Common.AreaUnitKey')}`
    )
  }

  if (matchedListing?.rent_price != null) {
    facts.push(
      t('RentalPortal.ApplicantProfileMatchedListingRentKey', {
        rent: getListingRentDisplayValue(matchedListing),
      })
    )
  }

  if (matchedListing?.available_from) {
    facts.push(
      t('RentalPortal.ApplicantProfileMatchedListingAvailableFromKey', {
        date: getApplicantShortDate(matchedListing.available_from),
      })
    )
  }

  return facts.join(RENTAL_PORTAL_FACT_SEPARATOR)
}

export function getApplicantMatchedListingUrl(matchedListing) {
  return PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
    id: matchedListing?.id,
  })
}
